import { ReactNode } from 'react';
import styled from 'styled-components';

import { c56EA99, cEA135E } from '#/colors';

import ArrowUpIcon from '#/assets/ArrowUpIcon';
import ArrowDownIcon from '#/assets/ArrowDownIcon';
import {
  LastTradeView,
  useLastTradeView,
} from '#/features/perpetuals/trades/last-trade-view-context';

const ICON_MAP: Record<LastTradeView['direction'], ReactNode> = {
  UP: <ArrowUpIcon aria-label="Price up" />,
  DOWN: <ArrowDownIcon aria-label="Price down" />,
  UNKNOWN: <span />,
};

export default function LastTradedPrice() {
  const lastTrade = useLastTradeView();

  const icon = ICON_MAP[lastTrade.direction];

  return (
    <Container side={lastTrade.side} data-testid="order-book-last-traded-price">
      {icon}
      <span>{lastTrade.price}</span>
    </Container>
  );
}

const Container = styled.span<{ side: 'BUY' | 'SELL' }>`
  display: grid;
  grid-template-columns: 12px auto;
  align-items: center;
  gap: 4px;
  color: ${({ side }) => (side === 'BUY' ? c56EA99 : cEA135E)};
  font-size: 18px;
  font-weight: 700;
`;
